"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _styles = require("@material-ui/core/styles");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _MainNavigationHorizontal = _interopRequireDefault(require("@sprinx/react-web/MainNavigationHorizontal"));

var _MainNavigationItemLink = _interopRequireDefault(require("@sprinx/react-web/MainNavigationItemLink"));

var _MainNavigationItemPopoverNestItem = _interopRequireDefault(require("@sprinx/react-web/MainNavigationItemPopoverNestItem"));

var _clsx = _interopRequireDefault(require("clsx"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _MainNavigationItemPopoverNest = _interopRequireDefault(require("./MainNavigationItemPopoverNest"));

var _MainNavigationNestItem = _interopRequireDefault(require("./MainNavigationNestItem"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _popup;

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.appBar,
      background: theme.palette.background.default,
      boxShadow: theme.shadows[2]
    },
    menuHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    popup: (_popup = {
      position: 'absolute',
      minWidth: 1232,
      width: '100%',
      top: '100%',
      left: 0,
      background: theme.palette.background.default,
      display: 'flex',
      flexWrap: 'wrap',
      padding: theme.spacing(2),
      boxShadow: theme.shadows[3]
    }, (0, _defineProperty2.default)(_popup, theme.breakpoints.down('sm'), {
      minWidth: 600
    }), (0, _defineProperty2.default)(_popup, theme.breakpoints.down('xs'), {
      minWidth: '100%'
    }), _popup),
    menuLinkContainer: {
      paddingBottom: theme.spacing(1.5)
    },
    last: {
      left: 'auto',
      right: 0
    },
    nest: (0, _defineProperty2.default)({
      alignItems: 'center'
    }, theme.breakpoints.down('xs'), {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1)
    }),
    navLink: {
      fontSize: 20,
      fontWeight: 300,
      '&:not(:last-of-type)': {
        marginRight: 24
      }
    },
    text: {
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 0,
      paddingLeft: theme.spacing(2)
    },
    popoverItem: {
      padding: theme.spacing(0.5, 0),
      '&:not(:last-child)': {
        borderRight: 'none',
        paddingRight: theme.spacing(2)
      },
      '&:not(:first-child)': {
        paddingLeft: 0
      }
    }
  };
}, {
  name: 'SxComMainNavigation'
});

var MainNavigation = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var AppBarActions = _ref.appBarActions,
      pClasses = _ref.classes,
      className = _ref.className,
      Logo = _ref.logo,
      menuItems = _ref.menuItems,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["appBarActions", "classes", "className", "logo", "menuItems"]);
  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      targetElement = _React$useState2[0],
      setTargetElement = _React$useState2[1];

  var t = (0, _useTranslate.default)();

  var handleOpenPopup = _react.default.useCallback(function (v) {
    return function () {
      setTargetElement(v);
    };
  }, [setTargetElement]);

  var handleClickMenuItem = _react.default.useCallback(function () {
    setTargetElement(null);
  }, [setTargetElement]);

  return menuItems ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.menuHeader
  }, /*#__PURE__*/_react.default.createElement(Logo, null), /*#__PURE__*/_react.default.createElement(AppBarActions, null)), /*#__PURE__*/_react.default.createElement(_MainNavigationHorizontal.default, {
    style: {
      position: 'relative'
    }
  }, (menuItems || []).map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index.toString(),
      onMouseLeave: handleOpenPopup(null),
      className: classes.menuLinkContainer
    }, /*#__PURE__*/_react.default.createElement(_MainNavigationItemLink.default, {
      classes: {
        root: classes.navLink
      },
      label: t(i.label),
      href: i.href,
      onMouseEnter: handleOpenPopup(index),
      onClick: handleClickMenuItem
    }), i.items && i.items.length ? /*#__PURE__*/_react.default.createElement("div", {
      label: t(i.label),
      style: {
        display: targetElement === index ? 'flex' : 'none'
      },
      onMouseLeave: handleOpenPopup(null),
      onClose: handleOpenPopup(null),
      className: (0, _clsx.default)(classes.popup, targetElement === menuItems.length - 1 && classes.last)
    }, i.items.map(function (s, idx) {
      return /*#__PURE__*/_react.default.createElement(_MainNavigationItemPopoverNest.default, {
        label: t(s.label),
        href: s.href,
        image: s.image,
        size: "small",
        ImageComponent: _MainNavigationNestItem.default,
        key: idx.toString(),
        classes: {
          root: (0, _clsx.default)(!s.items && classes.nest),
          text: classes.text
        }
      }, s.items && s.items.length ? s.items.map(function (ss, sidx) {
        return /*#__PURE__*/_react.default.createElement(_MainNavigationItemPopoverNestItem.default, {
          classes: {
            root: classes.popoverItem
          },
          key: sidx.toString(),
          href: ss.href
        }, t(ss.label));
      }) : null);
    })) : null);
  })))) : null;
});

process.env.NODE_ENV !== "production" ? MainNavigation.propTypes = {
  appBarActions: _propTypes.default.shape({}),
  classes: _propTypes.default.shape({
    last: _propTypes.default.string,
    menuHeader: _propTypes.default.string,
    menuLinkContainer: _propTypes.default.string,
    navLink: _propTypes.default.string,
    nest: _propTypes.default.string,
    nestLinks: _propTypes.default.string,
    popoverItem: _propTypes.default.string,
    popup: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  logo: _propTypes.default.func,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired
} : void 0;
MainNavigation.defaultProps = {
  appBarActions: undefined,
  classes: undefined,
  className: undefined,
  logo: undefined
};
var _default = MainNavigation;
exports.default = _default;